import React from 'react';
import { Compass } from 'lucide-react';
import EmailOptIn from './EmailOptIn';

const Footer: React.FC = () => {
  return (
    <footer className="py-12 bg-dark text-white/60">
      <div className="container mx-auto px-6">
        <div className="max-w-xl mx-auto mb-16">
          <h3 className="text-2xl font-serif text-white text-center mb-6">
            Join <span className="text-primary">500</span> Founding Members
          </h3>
          <EmailOptIn />
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="flex items-center mb-6 md:mb-0">
            <Compass className="w-6 h-6 text-primary mr-2" />
            <span className="text-xl font-semibold text-white">HELM</span>
          </div>
          
          <div className="flex flex-col md:flex-row items-center space-y-4 md:space-y-0 md:space-x-8">
            <a href="#" className="text-sm hover:text-white transition-colors duration-300">
              Privacy Policy
            </a>
            <a href="#" className="text-sm hover:text-white transition-colors duration-300">
              Terms of Service
            </a>
            <a href="#" className="text-sm hover:text-white transition-colors duration-300">
              Contact
            </a>
          </div>
        </div>
        
        <div className="w-full h-px bg-white/10 my-8"></div>
        
        <div className="text-center text-white/40 text-sm">
          &copy; {new Date().getFullYear()} HELM. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;